function getFocusableElements(container) {
  if(!container) {
    return [];
  }
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary?.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && !parentMenuElement.querySelector('.accordion') && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(null);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SwiperComponent extends HTMLElement {
  constructor () {
    super();
    const defaults = {
      slidesPerView: 'auto',
      autoHeight: false,
      spaceBetween: 18,
      centeredSlides: false,
      initialSlide: 0,
      loop: false,
      freeMode: false,
      autoplay:false,
      edgeSwipeThreshold: 5,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {},
    };
    let params = {};
    try{
      params = JSON.parse(this.getAttribute('data-options'));
    }catch (e) {
      console.warn(e, this.getAttribute('data-options'));
    }
    params = this.mergeParams(defaults, params);
    this.swiper = new Swiper(this, params);
  }
  mergeParams (target, source) {
    const isObject = (obj) => obj && typeof obj === 'object';

    if (!isObject(target) || !isObject(source)) {
      return source;
    }

    Object.keys(source).forEach(key => {
      const targetValue = target[key];
      const sourceValue = source[key];

      if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
        target[key] = targetValue.concat(sourceValue);
      } else if (isObject(targetValue) && isObject(sourceValue)) {
        target[key] = this.mergeParams(Object.assign({}, targetValue), sourceValue);
      } else {
        target[key] = sourceValue;
      }
    });

    return target;
  }
}

customElements.define('swiper-component', SwiperComponent);


class StepControlsComponent extends HTMLElement {
  constructor () {
    super();
    const mainSlider = this.querySelector('[data-control-role="main"]');
    const thumbSlider =  this.querySelector('[data-control-role="thumbs"]');
    if(thumbSlider && mainSlider) {
      thumbSlider.swiper.on('click', function(swiper){
        mainSlider.classList.add('hidden-preview');
      });
    }
  }
}

customElements.define('step-controls-component', StepControlsComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide?.classList.add(`${animationClassOut}-${direction}`);
    nextSlide?.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide?.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide?.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        let buttonPrice = addButtonUpdated.querySelector('[data-wpd-product-handle]');
        if(!buttonPrice) {
          buttonPrice = null;
        }
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut, true, buttonPrice);
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, buttonPrice = null) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    let addButtonText = productForm.querySelector('[name="add"] > span');
    if(addButtonText.classList.contains('b2b-atc-wrapper')) {
      if(buttonPrice) {
        addButtonText.querySelector('[data-wpd-product-handle]').remove();
        addButtonText.insertBefore(buttonPrice, addButtonText.firstChild);
        const quantityCharger = addButtonText.closest('quantity-changer');
        if(quantityCharger) {
          quantityCharger.setAttribute('data-per-item-price', buttonPrice.getAttribute('data-wpd-variant-price'));
        }
      }
      addButtonText = addButtonText.querySelector('span:last-child');
    }
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      let buttonValue = window?.variantStrings?.addToCart?? 'ADD TO CART';
      if(window?.variantStrings?.atcButtonValue) {
        buttonValue = window.variantStrings.atcButtonValue;
      }
      addButtonText.textContent = buttonValue;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function goToElement(force, animation = 'auto') {
  const hash = !force ? window.location.hash.replace('#', '') : String(force).replace('#', '');
  if (!hash) return;

  let targetElement = document.querySelector('[data-id="' + hash + '"]');
    if (!targetElement) {
    const esc = (window.CSS && CSS.escape) ? CSS.escape(hash) : hash.replace(/[^a-zA-Z0-9_\-:.]/g, '\\$&');
    targetElement = document.querySelector('#' + esc);
    }
  if (!targetElement) return;

  if (!targetElement.hasAttribute('data-page')) {
        const header = document.querySelector('sticky-header');
    const offset = header ? header.clientHeight : 0;

      const top = targetElement.getBoundingClientRect().top - offset + window.pageYOffset;
      const headerDrawer = document.querySelector('header-drawer');
      if (headerDrawer && headerDrawer.querySelector('details[open]') && headerDrawer.querySelector('summary')) {
        headerDrawer.querySelector('summary').dispatchEvent(new Event('click'));
      }
   window.scrollTo({ top, behavior: animation === 'smooth' ? 'smooth' : 'auto' });
    }
  }

function isSameDocument(url) {
  return (
    url.origin === window.location.origin &&
    url.pathname === window.location.pathname &&
    url.search === window.location.search
  );
}

function hasDomTarget(hash) {
  const id = String(hash || '').replace(/^#/, '');
  if (!id) return false;
  if (document.querySelector('[data-id="' + id + '"]')) return true;

  const esc = (window.CSS && CSS.escape) ? CSS.escape(id) : id.replace(/[^a-zA-Z0-9_\-:.]/g, '\\$&');
  return !!document.querySelector('#' + esc);
}

window.addEventListener('hashchange', () => {
  goToElement(undefined, 'smooth');
});
window.addEventListener('load', () => {
  if (window.location.hash && hasDomTarget(window.location.hash)) {
    goToElement(); // animation = 'auto'
  }
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href*="#"]:not([data-disabled-scroll-to])').forEach((link) => {
    link.addEventListener('click', (e) => {
      const a = /** @type {HTMLAnchorElement} */ (e.currentTarget);
      const rawHref = a.getAttribute('href') || '';
      let url;
      try {
        url = new URL(rawHref, window.location.href);
      } catch {
        return;
      }
      const onlyHash = rawHref.startsWith('#') && !!url.hash && (url.pathname === window.location.pathname);
      const sameDocWithHash = !!url.hash && isSameDocument(url);
      const canSmoothScroll = (onlyHash || sameDocWithHash) && hasDomTarget(url.hash);

      if (!canSmoothScroll) return;
      e.preventDefault();

      if (url.hash !== window.location.hash) {
        history.pushState(null, '', url.hash);
      }

          goToElement(url.hash, 'smooth');
    });
  });
  document.querySelectorAll('a[href*="/account/logout"]').forEach((link)=>{
    link.addEventListener('click', async (e) => {
      e.preventDefault();
      await fetch(link.getAttribute('href'), { method: 'GET' });
      window.location.replace('/');
    });
  });
});

(() => {
  class AppstlePdpWidgetCustomizer {
    constructor () {
      this.storedSubInfo = null;
      this.targetContainer = null;
      this.insertPosition = null;

      this._observer = null;
      this._unsubVariant = null;

      this._onDomReady = this._onDomReady.bind(this);
      this._onMutations = this._onMutations.bind(this);
      this.updateButtonPrice = this.updateButtonPrice.bind(this);
    }

    _getClosestProductForm () {
      const widget = document.querySelector('#appstle_subscription_widget0');
      return widget ? widget.closest('product-form') : null;
    }

    _readJsonOrRawAttr (el, attrName) {
      if (!el) return null;
      const raw = el.getAttribute(attrName);
      if (!raw) return null;

      try {
        const parsed = JSON.parse(raw);
        return typeof parsed === 'string' ? parsed : raw;
      } catch {
        return raw;
      }
    }

    getFeaturedImageUrlFromProductForm () {
      const pf = this._getClosestProductForm();
      return this._readJsonOrRawAttr(pf, 'data-featured-image');
    }

    getSubscriptionIconUrlFromProductForm () {
      const pf = this._getClosestProductForm();
      return this._readJsonOrRawAttr(pf, 'data-subscription-icon');
    }

    // =========================
    // Insert product image into label.appstle_radio_label
    // =========================
    ensureSubscriptionProductImage () {
      const widget = document.querySelector('#appstle_subscription_widget0');
      if (!widget) return false;

      const option =
        widget.querySelector('.payAsYouGoPlansDropdownWrapper.appstle-active-option') ||
        widget.querySelector('.payAsYouGoPlansDropdownWrapper');

      if (!option) return false;

      const url = this.getFeaturedImageUrlFromProductForm();
      if (!url) return false;

      const label =
        option.querySelector('label.appstle_radio_label[for^="appstle_selling_plan_label_"]') ||
        option.querySelector('label.appstle_radio_label');

      if (!label) return false;

      let img = label.querySelector('img.appstle-product-image');
      if (!img) {
        img = document.createElement('img');
        img.className = 'appstle-product-image';
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        label.insertBefore(img, label.firstChild);
      }

      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      return true;
    }

    initSubscriptionProductImage () {
      let attempts = 0;
      const maxAttempts = 20;

      const tryInit = () => {
        if (this.ensureSubscriptionProductImage()) return;
        if (attempts >= maxAttempts) return;
        attempts += 1;
        setTimeout(tryInit, 250);
      };

      tryInit();
    }

    // =========================
    // appstle-save-badge.innerHTML = <img src="...">
    // =========================
    ensureSaveBadgeIcon () {
      const iconUrl = this.getSubscriptionIconUrlFromProductForm();
      if (!iconUrl) return false;

      const widget = document.querySelector('#appstle_subscription_widget0');
      if (!widget) return false;

      const badge = widget.querySelector('.payAsYouGoPlansDropdownWrapper .appstle-save-badge');
      if (!badge) return false;

      // Guard: do nothing if already correct (prevents mutation loops)
      const existingImg = badge.querySelector('img.appstle-save-badge-icon');
      if (existingImg && existingImg.getAttribute('src') === iconUrl) return true;

      // requirement: salebadge.innerHTML = ...
      badge.innerHTML = `<img class="appstle-save-badge-icon" src="${iconUrl}" alt="">`;
      return true;
    }

    // Add this method inside AppstlePdpWidgetCustomizer (don’t change other code)
    ensureBestValueBadgeFirstInWrapper () {
      const widget = document.querySelector('#appstle_subscription_widget0');
      if (!widget) return false;

      const wrapper = widget.querySelector('.appstle_subscription_wrapper');
      if (!wrapper) return false;

      // the badge is inside the subscription option
      const badge = widget.querySelector('.appstle_bundle_discount_amount.subscription_discount');
      if (!badge) return false;

      // already first child
      if (wrapper.firstElementChild === badge) return true;

      // move it to the very top of wrapper
      wrapper.insertBefore(badge, wrapper.firstChild);
      return true;
    }

    formatMoneyText (text) {
      if (!text) return text;
      return String(text).replace(/([.,]00)\s*$/, '') // strip decimal zeros at end
        .trim();
    }

    _parseMoney (text) {
      if (!text) return null;

      const cleaned = String(text).replace(/[^\d.,]/g, '').trim();
      if (!cleaned) return null;

      let normalized = cleaned;

      // "1,234.56" -> "1234.56"
      if (cleaned.includes('.') && cleaned.includes(',')) normalized = cleaned.replace(/,/g, '');
      // "1234,56" -> "1234.56"
      else if (!cleaned.includes('.') && cleaned.includes(',')) normalized = cleaned.replace(',', '.');

      const n = Number(normalized);
      return Number.isFinite(n) ? n : null;
    }

    _formatMoneyNum (num) {
      if (num == null || !Number.isFinite(num)) return '';
      const s = Number(num).toFixed(2);
      return (s.endsWith('.00') ? s.slice(0, -3) : s).replace(/^/, '$');
    }

    _getSelectedUpsellPrices () {
      const wrapper = document.querySelector('.upsell-products-wrapper');
      if (!wrapper) return null;
      const checkbox = wrapper.querySelector('input[name*="related-product"]:checked');
      const label = checkbox && checkbox.closest('label[data-product-price]');
      if (!label) return null;
      const priceCents = parseInt(label.getAttribute('data-product-price'), 10);
      const compareCents = parseInt(label.getAttribute('data-product-compare-at-price'), 10);
      return {
        priceCents: Number.isFinite(priceCents) ? priceCents : 0,
        compareAtCents: Number.isFinite(compareCents) ? compareCents : 0,
      };
    }

    formatAllAppstlePrices () {
      const widget = document.querySelector('#appstle_subscription_widget0');
      if (!widget) return false;

      // price nodes we want to format (regular + compare, subscription + one-time)
      const selectors = [
        // subscription
        '.payAsYouGoPlansDropdownWrapper .appstle_subscription_amount.transcy-money:not(.sr-only)',
        '.payAsYouGoPlansDropdownWrapper .appstle_subscription_compare_amount.transcy-money:not(.sr-only)',

        // one-time
        '.appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money:not(.sr-only)',
        '.appstle_one_time_price_wrapper .appstle_subscription_amount_compare_at_price.transcy-money:not(.sr-only)',
      ];

      let changed = false;

      selectors.forEach((sel) => {
        widget.querySelectorAll(sel).forEach((el) => {
          const current = (el.textContent || '').trim();
          if (!current) return;

          const next = this.formatMoneyText(current);
          if (next !== current) {
            el.textContent = next;
            changed = true;
          }
        });
      });

      return changed;
    }

    syncSubscriptionCompareWithOneTimeIfBigger () {
      const widget = document.querySelector('#appstle_subscription_widget0');
      if (!widget) return false;

      const subOption =
        widget.querySelector('.payAsYouGoPlansDropdownWrapper.appstle-active-option') ||
        widget.querySelector('.payAsYouGoPlansDropdownWrapper');
      if (!subOption) return false;

      const subCompareEl = subOption.querySelector('.appstle_subscription_compare_amount.transcy-money:not(.sr-only)');
      if (!subCompareEl) return false;

      const oneTimeCompareEl = widget.querySelector(
        '.appstle_one_time_price_wrapper .appstle_subscription_amount_compare_at_price.transcy-money:not(.sr-only)',
      );
      if (!oneTimeCompareEl) return false;

      const subCompareRaw = (subCompareEl.textContent || '').trim();
      const oneTimeCompareRaw = (oneTimeCompareEl.textContent || '').trim();

      const subCompare = this._parseMoney(subCompareRaw);
      const oneTimeCompare = this._parseMoney(oneTimeCompareRaw);

      if (!subCompare || !oneTimeCompare) return false;

      // If one-time compare is bigger -> overwrite subscription compare text (formatted)
      if (oneTimeCompare > subCompare) {
        const nextText = this.formatMoneyText(oneTimeCompareRaw);

        // Guard: do nothing if already replaced
        if ((subCompareEl.textContent || '').trim() === nextText) return true;

        subCompareEl.textContent = nextText;
        return true;
      }

      // still ensure formatting
      const formatted = this.formatMoneyText(subCompareRaw);
      if (formatted !== subCompareRaw) {
        subCompareEl.textContent = formatted;
        return true;
      }

      return false;
    }

    ensurePriceFormattingAndCompareSync () {
      // 1) first sync compare (may change sub compare)
      const didSync = this.syncSubscriptionCompareWithOneTimeIfBigger();

      // 2) then format all visible prices (regular + compare, both widgets)
      const didFormat = this.formatAllAppstlePrices();

      return didSync || didFormat;
    }

    ensureSubscriptionDiscountPercentBadge () {
      const widget = document.querySelector('#appstle_subscription_widget0');
      if (!widget) return false;

      const option =
        widget.querySelector('.payAsYouGoPlansDropdownWrapper.appstle-active-option') ||
        widget.querySelector('.payAsYouGoPlansDropdownWrapper');
      if (!option) return false;

      // Target: span.appstle_bundle_discount_amount.subscription_discount
      const discountEl = option.querySelector('.appstle_bundle_discount_amount.subscription_discount');
      if (!discountEl) return false;

      const html = 'BEST VALUE';

      // Guard: avoid re-writing same content (prevents mutation loops)
      if ((discountEl.innerHTML || '').trim() === html) return true;

      // Requirement: set via innerHTML
      discountEl.innerHTML = 'BEST VALUE';
      return true;
    }

    // Add this method inside AppstlePdpWidgetCustomizer (same style as existing code)
    ensureSaveTextFromDescription () {
      const widget = document.querySelector('#appstle_subscription_widget0');
      if (!widget) return false;

      const option =
        widget.querySelector('.payAsYouGoPlansDropdownWrapper.appstle-active-option') ||
        widget.querySelector('.payAsYouGoPlansDropdownWrapper');
      if (!option) return false;

      const descWrap = option.querySelector('.appstleSelectedSellingPlanOptionDescription');
      if (!descWrap) return false;

      const firstP = descWrap.querySelector('p');
      const text = firstP ? (firstP.textContent || '').trim() : '';
      if (!text) return false;

      // Where to insert: right after .appstle-save-badge
      const badge = option.querySelector('.appstle-save-badge');
      if (!badge || !badge.parentNode) return false;

      let extra = option.querySelector('span.appstle-subscribe-save-extra');
      if (!extra) {
        extra = document.createElement('span');
        extra.className = 'appstle-subscribe-save-extra';
        // insert after badge
        badge.parentNode.insertBefore(extra, badge.nextSibling);
      }

      // Guard to avoid loops
      if ((extra.textContent || '').trim() === text) {
        if (firstP && firstP.style.display !== 'none') firstP.style.display = 'none';
        return true;
      }

      extra.textContent = text;
      if (firstP) firstP.style.display = 'none';

      return true;
    }

    ensureOneTimeSaveText () {
      const widget = document.querySelector('#appstle_subscription_widget0');
      if (!widget) return false;

      const oneTimeOption =
        widget.querySelector('.appstle_subscription_wrapper_option:has(.appstle_one_time_text)') ||
        widget.querySelector('.appstle_one_time_text')?.closest('.appstle_subscription_wrapper_option') ||
        null;

      if (!oneTimeOption) return false;

      const oneTimeTextEl = oneTimeOption.querySelector('.appstle_one_time_text');
      if (!oneTimeTextEl || !oneTimeTextEl.parentNode) return false;

      const priceEl = oneTimeOption.querySelector(
        '.appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money:not(.sr-only)',
      );
      const compareEl = oneTimeOption.querySelector(
        '.appstle_one_time_price_wrapper .appstle_subscription_amount_compare_at_price.transcy-money:not(.sr-only)',
      );

      if (!priceEl || !compareEl) return false;

      const parseMoney = (s) => {
        if (!s) return null;
        const cleaned = String(s).replace(/[^\d.,]/g, '').trim();
        if (!cleaned) return null;

        let normalized = cleaned;
        if (cleaned.includes('.') && cleaned.includes(',')) normalized = cleaned.replace(/,/g, '');
        else if (!cleaned.includes('.') && cleaned.includes(',')) normalized = cleaned.replace(',', '.');

        const n = Number(normalized);
        return Number.isFinite(n) ? n : null;
      };

      const price = parseMoney(priceEl.textContent);
      const compare = parseMoney(compareEl.textContent);

      if (!price || !compare || compare <= 0 || price >= compare) return false;

      const pct = Math.round(((compare - price) / compare) * 100);
      if (!Number.isFinite(pct) || pct <= 0) return false;

      const text = `Save ${pct}% on sets`;
      let extra = oneTimeOption.querySelector('span.appstle-subscribe-save-extra--one-time');
      if (!extra) {
        extra = document.createElement('span');
        extra.className = 'appstle-subscribe-save-extra appstle-subscribe-save-extra--one-time';
        oneTimeTextEl.parentNode.insertBefore(extra, oneTimeTextEl.nextSibling);
      }

      if ((extra.textContent || '').trim() === text) return true;

      extra.textContent = text;
      return true;
    }

    _onMutations (mutations) {
      let shouldEnsureImage = false;
      let shouldEnsureBadgeIcon = false;
      let shouldSaveTextFromDescription = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          shouldEnsureImage = true;
          shouldEnsureBadgeIcon = true;
          shouldSaveTextFromDescription = true;
        }

        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;

          if (target?.classList?.contains('appstle_hide_subsOption')) {
            target.classList.remove('appstle_hide_subsOption');
            shouldEnsureImage = true;
          }

          if (
            target?.classList?.contains('payAsYouGoPlansDropdownWrapper') &&
            !target.classList.contains('appstle-active-optionhere')
          ) {
            target.classList.add('appstle-active-optionhere');
            shouldEnsureImage = true;
          }

          shouldEnsureBadgeIcon = true;
          shouldSaveTextFromDescription = true;
        }
      });

      if (shouldEnsureImage) this.ensureSubscriptionProductImage();
      if (shouldEnsureBadgeIcon) this.ensureSaveBadgeIcon();
      if (shouldSaveTextFromDescription) this.ensureSaveTextFromDescription();
      if (shouldEnsureBadgeIcon) this.ensureSubscriptionDiscountPercentBadge();
      if (shouldEnsureBadgeIcon) this.ensureBestValueBadgeFirstInWrapper();
      if (shouldEnsureBadgeIcon) this.ensureOneTimeSaveText();
      if (shouldEnsureBadgeIcon) this.ensurePriceFormattingAndCompareSync();

      const subInfo = document.querySelector('.appstleSelectedSellingPlanOptionDescription');

      if (subInfo) {
        this.storedSubInfo = subInfo.cloneNode(true);
        this.targetContainer = subInfo.parentElement;
        this.insertPosition = subInfo.nextSibling;
      }

      if (!subInfo && this.storedSubInfo && this.targetContainer) {
        if (this.insertPosition && this.insertPosition.parentNode === this.targetContainer) {
          this.targetContainer.insertBefore(this.storedSubInfo.cloneNode(true), this.insertPosition);
        } else {
          this.targetContainer.appendChild(this.storedSubInfo.cloneNode(true));
        }
      }
    }

    startObserver () {
      const mainContent = document.querySelector('.appstle_subscription_wrapper') || document.body;

      if (this._observer) {
        try {
          this._observer.disconnect();
        } catch {}
      }

      this._observer = new MutationObserver(this._onMutations);
      this._observer.observe(mainContent, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    updateButtonPrice () {
      const submitLabel = document.querySelector('.product-form__submit-label');
      if (!submitLabel) return;

      const selectedPlan = document.querySelector('input[name="selling_plan"]:checked');
      const upsell = this._getSelectedUpsellPrices();

      let buttonValue = window?.variantStrings?.addToCart ?? 'ADD TO BAG';
      if (window?.variantStrings?.atcButtonValue) {
        buttonValue = window.variantStrings.atcButtonValue;
      }

      const applyUpsellToTotals = (mainPriceNum, mainCompareNum) => {
        if (!upsell || !upsell.priceCents) return { priceStr: null, compareStr: null };
        const upsellPrice = upsell.priceCents / 100;
        const upsellCompareAt = (upsell.compareAtCents > 0) ? upsell.compareAtCents / 100 : 0;
        const totalPrice = mainPriceNum + upsellPrice;
        const totalCompare = (mainCompareNum != null ? mainCompareNum : mainPriceNum) + upsellCompareAt;
        const compareStr = totalCompare > totalPrice ? this._formatMoneyNum(totalCompare) : null;
        return {
          priceStr: this._formatMoneyNum(totalPrice),
          compareStr,
        };
      };

      const showCompareOnlyWhenGreater = (priceStr, compareStr) => {
        if (!compareStr) return '';
        const priceNum = this._parseMoney(priceStr);
        const compareNum = this._parseMoney(compareStr);
        if (priceNum == null || compareNum == null || compareNum <= priceNum) return '';
        return compareStr;
      };

      if (selectedPlan && selectedPlan.value) {
        const activeSubOption = document.querySelector('.appstle_subscription_wrapper_option.appstle-active-option');

        if (activeSubOption) {
          const subPrice = activeSubOption.querySelector('.appstle_subscription_amount.transcy-money:not(.sr-only)');
          const comparePrice = activeSubOption.querySelector('.appstle_subscription_compare_amount.transcy-money:not(.sr-only)');

          if (subPrice && comparePrice) {
            let priceStr = subPrice.textContent.trim();
            let compareStr = comparePrice.textContent.trim();
            const mainPriceNum = this._parseMoney(priceStr);
            const mainCompareNum = this._parseMoney(compareStr);
            if (upsell && upsell.priceCents && mainPriceNum != null) {
              const combined = applyUpsellToTotals(mainPriceNum, mainCompareNum);
              if (combined.priceStr) priceStr = combined.priceStr;
              if (combined.compareStr) compareStr = combined.compareStr;
            }
            compareStr = showCompareOnlyWhenGreater(priceStr, compareStr);
            if (compareStr) {
              submitLabel.innerHTML = `
                <div class="price product-form__submit-price price--on-sale">
                  <div class="price__container">
                    <div class="price__sale">
                      <span class="price-item price-item--sale">
                        <span>${priceStr}</span>
                      </span>
                      <s class="price-item price-item--regular price-item--last" style="">
                        <span>${compareStr}</span>
                      </s>
                    </div>
                  </div>
                </div>
                ${buttonValue}
              `;
            } else {
              submitLabel.innerHTML = `
                <div class="price product-form__submit-price">
                  <span class="price-item price-item--regular">
                    ${priceStr}
                  </span>
                </div>
                ${buttonValue}
              `;
            }
          }
        }
      } else {
        const oneTimePrice = document.querySelector(
          '.appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money:not(.sr-only)',
        );
        const oneTimeCompare = document.querySelector(
          '.appstle_one_time_price_wrapper .appstle_subscription_amount_compare_at_price.transcy-money:not(.sr-only)',
        );

        if (oneTimePrice) {
          let priceStr = oneTimePrice.textContent.trim();
          let compareStr = oneTimeCompare && oneTimeCompare.textContent.trim() ? oneTimeCompare.textContent.trim() : '';
          const mainPriceNum = this._parseMoney(priceStr);
          const mainCompareNum = compareStr ? this._parseMoney(compareStr) : null;
          if (upsell && upsell.priceCents && mainPriceNum != null) {
            const combined = applyUpsellToTotals(mainPriceNum, mainCompareNum);
            if (combined.priceStr) priceStr = combined.priceStr;
            if (combined.compareStr) compareStr = combined.compareStr;
          }
          compareStr = showCompareOnlyWhenGreater(priceStr, compareStr);
          if (compareStr) {
            submitLabel.innerHTML = `
              <div class="price product-form__submit-price price--on-sale">
                <div class="price__container">
                  <div class="price__sale">
                    <span class="price-item price-item--sale">
                      <span>${priceStr}</span>
                    </span>
                    <s class="price-item price-item--regular price-item--last" style="">
                      <span>${compareStr}</span>
                    </s>
                  </div>
                </div>
              </div>
              ${buttonValue}
            `;
          } else {
            submitLabel.innerHTML = `
              <div class="price product-form__submit-price">
                <span class="price-item price-item--regular">
                  ${priceStr}
                </span>
              </div>
              ${buttonValue}
            `;
          }
        }
      }
    }

    initButtonPrice () {
      let attempts = 0;
      const maxAttempts = 10;

      const tryUpdate = () => {
        const appstle = document.querySelector('#appstle_subscription_widget0');
        const prices = document.querySelectorAll('.appstle_subscription_amount.transcy-money');

        if (appstle && prices.length > 0) {
          this.updateButtonPrice();
        } else if (attempts < maxAttempts) {
          attempts += 1;
          setTimeout(tryUpdate, 200);
        }
      };

      tryUpdate();
    }

    bindEvents () {
      document.addEventListener('change', (e) => {
        if (e?.target?.name === 'selling_plan') {
          setTimeout(this.updateButtonPrice, 200);
          setTimeout(() => this.ensureSaveBadgeIcon(), 200);
          setTimeout(() => this.ensureSubscriptionDiscountPercentBadge(), 200);
          setTimeout(() => this.ensureBestValueBadgeFirstInWrapper(), 220);
          setTimeout(() => this.ensureOneTimeSaveText(), 200);
          setTimeout(() => this.ensurePriceFormattingAndCompareSync(), 220);
        }
        if (e?.target?.closest?.('.upsell-products-wrapper') && e?.target?.name?.startsWith?.('related-product-')) {
          setTimeout(this.updateButtonPrice, 100);
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target && e.target.closest && e.target.closest('.appstle_subscription_wrapper_option')) {
          setTimeout(this.updateButtonPrice, 200);
          setTimeout(() => this.ensureSubscriptionProductImage(), 200);
          setTimeout(() => this.ensureSaveBadgeIcon(), 200);
          setTimeout(() => this.ensureSubscriptionDiscountPercentBadge(), 200);
          setTimeout(() => this.ensureOneTimeSaveText(), 200);
          setTimeout(() => this.ensurePriceFormattingAndCompareSync(), 220);
        }
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          setTimeout(() => this.ensureSubscriptionProductImage(), 150);
          setTimeout(() => this.ensureSaveBadgeIcon(), 150);
          setTimeout(() => this.ensureSubscriptionDiscountPercentBadge(), 150);
          setTimeout(() => this.ensureOneTimeSaveText(), 150);
          setTimeout(() => this.ensurePriceFormattingAndCompareSync(), 170);
        });
      }
    }

    _onDomReady () {
      this.initSubscriptionProductImage();
      this.ensureSaveBadgeIcon();
      this.ensureSaveTextFromDescription();
      this.ensureSubscriptionDiscountPercentBadge();
      this.ensureOneTimeSaveText();
      this.ensurePriceFormattingAndCompareSync();
      this.ensureBestValueBadgeFirstInWrapper();

      this.startObserver();
      this.initButtonPrice();
      this.bindEvents();

    }

    init () {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this._onDomReady);
      } else {
        this._onDomReady();
      }
    }
  }

  new AppstlePdpWidgetCustomizer().init();
})();



document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const openCartParam = (params.get('open_cart') || '').toLowerCase();

  const isForce = openCartParam === 'force';
  const shouldTryOpen =
    isForce || openCartParam === 'true' || openCartParam === '1' || openCartParam === 'yes';

  if (!shouldTryOpen) return;

  const isHome = window.location.pathname === '/';
  if (!isForce && !isHome) return;

  const openDrawer = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return true;
    }
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      cartIcon.click();
      return true;
    }
    return false;
  };

  const fetchCartItemCount = async () => {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return 0;
      const cart = await res.json();
      return Number(cart?.item_count || 0);
    } catch {
      return 0;
    }
  };

  (async () => {
    if (isForce) {
      const attempts = [0, 150, 350, 700, 1200, 2000];
      for (const waitMs of attempts) {
        if (waitMs) await new Promise((r) => setTimeout(r, waitMs));
        if (openDrawer()) break;
      }
    } else {
      const attempts = [0, 150, 350, 700, 1200, 2000];
      for (const waitMs of attempts) {
        if (waitMs) await new Promise((r) => setTimeout(r, waitMs));
        const count = await fetchCartItemCount();
        if (count > 0) {
          openDrawer();
          break;
        }
      }
    }

    params.delete('open_cart');
    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : '') +
      window.location.hash;
    window.history.replaceState({}, '', newUrl);
  })();
});



